import cookie from './cookie.js'

/*
 * localStorage outlives the login session, so data cached for one customer (e.g. prices based on their price
 * agreements) would otherwise be shown to whoever uses the browser next. The server keeps the identity cookie in
 * sync with the authenticated customer (see CustomerCookieSubscriber); whenever it differs from the identity the
 * storage was filled for (login, logout, expired session, other account), all customer-scoped entries are wiped.
 *
 * This runs on import so it is guaranteed to happen before any module reads from the storage.
 */
const IDENTITY_COOKIE = 'external_id_sha256'
const IDENTITY_STORAGE_KEY = 'customer-storage-identity'
const CUSTOMER_SCOPED_PREFIXES = ['product-price-id-', 'product_calculator:', 'AUTOCOMPLETE_RECENT_SEARCHES:', 'algoliasearch-']

const syncCustomerStorage = () => {
  try {
    const identity = cookie.get(IDENTITY_COOKIE) ?? ''

    if (localStorage.getItem(IDENTITY_STORAGE_KEY) === identity) {
      return
    }

    Object.keys(localStorage)
      .filter((key) => CUSTOMER_SCOPED_PREFIXES.some((prefix) => key.startsWith(prefix)))
      .forEach((key) => localStorage.removeItem(key))

    localStorage.setItem(IDENTITY_STORAGE_KEY, identity)
  } catch {
    // Without localStorage there is nothing to clear.
  }
}

syncCustomerStorage()
